<template>
    <div>
        <v-data-table :headers="headers" :items="current_people" :loading="table_loader" hide-actions>
            <template slot="items" slot-scope="props">
                <tr class="clickable" @mouseup.left="profile(props.item.people_id)">
                    <td><img :src="props.item.photo" @error="imageLoadError" style="max-width: 50px; max-height: 50px" /></td>
                    <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
                    <td>{{ props.item.login_type ? $t(`lang.${props.item.login_type}`) : null }}</td>
                    <td class="text-center">{{ props.item.last_login }}</td>
                    <td>
                        <v-layout justify-center>
                            <v-chip label text-color="white" :color="props.item.has_user_account_class">
                                <span
                                    ><v-icon>{{ props.item.has_user_account_icon }}</v-icon></span
                                >
                            </v-chip>
                        </v-layout>
                    </td>
                </tr>
            </template>
            <template slot="no-data">
                <tr class="no-hover">
                    <td class="w-100" :colspan="headers.length">
                        <v-layout>
                            <v-flex class="text-center align-content-center" :style="$bp.smallScreen ? 'margin-top:16px;' : 'height:calc(100vh - 300px)'">
                                <span class="blue-grey--text text--lighten-4 display-1">{{
                                    table_loader ? $t("lang.loading") : $t("lang.no_users_available")
                                }}</span>
                            </v-flex>
                        </v-layout>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <bc-pagination :page="page" :params="axiosParams" sendFetch="fetchPeople"></bc-pagination>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AppConfig from "Constants/AppConfig";

export default {
    name: "users",
    data() {
        return {
            headers: [
                { text: "", sortable: false, align: "center", width: "60" },
                { text: this.$t("lang.name"), sortable: false },
                { text: this.$t("lang.login_type"), sortable: false },
                { text: this.$t("lang.last_login"), sortable: false, align: "center", width: "200" },
                { text: this.$t("lang.has_user_account"), sortable: false, align: "center", width: "140" },
            ],
            company_id: null,
            settings: {
                maxScrollbarLength: 150,
            },
            table_loader: true,
            filter: {
                search: null,
                login_type: null,
                has_user_account: null,
                company_id: null,
                page_size: 2,
                page_num: 1,
            },
        };
    },
    mounted: function () {
        this.company_id = this.$route.params.id;
        this.getPeople();
    },
    computed: {
        ...mapState({
            page: (state) => state.people.page,
            current_people: (state) => state.people.people,
            default_filter: (state) => state.people.people_filter,
        }),
        axiosParams() {
            this.filter.company_id = this.company_id;
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchPeople"]),
        imageLoadError(event) {
            event.target.src = AppConfig.baseApiUrl + "public/users/default.png";
        },
        getPeople() {
            this.table_loader = true;

            this.fetchPeople({ body: { company_id: this.company_id } })
                .then((data) => {})
                .finally(() => (this.table_loader = false));
        },
        profile(id) {
            const _id = id;
            this.$router.push({ name: "person", params: { id: _id } });
        },
    },
};
</script>
